function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e(require("quill")) : "function" == typeof define && define.amd ? define(["quill"], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.QuillForm = e(require("quill")) : t.QuillForm = e(t.Quill);
}(window, function (t) {
  return function (t) {
    var e = {};

    function i(n) {
      if (e[n]) return e[n].exports;
      var r = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
    }

    return i.m = t, i.c = e, i.d = function (t, e, n) {
      i.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, i.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, i.t = function (t, e) {
      if (1 & e && (t = i(t)), 8 & e) return t;
      if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
      var n = Object.create(null);
      if (i.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var r in t) {
        i.d(n, r, function (e) {
          return t[e];
        }.bind(null, r));
      }
      return n;
    }, i.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return i.d(e, "a", e), e;
    }, i.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, i.p = "", i(i.s = 1);
  }([function (e, i) {
    e.exports = t;
  }, function (t, e, i) {
    "use strict";

    i.r(e), i.d(e, "default", function () {
      return o;
    });
    var n = i(0),
        r = i.n(n);
    var l = r.a.import("core/module");

    var o = /*#__PURE__*/function (_l) {
      _inherits(o, _l);

      var _super = _createSuper(o);

      function o(t, e) {
        var _this;

        _classCallCheck(this, o);

        _this = _super.call(this, t, e), _this.htmlField = s(e.htmlField, t), _this.deltaField = s(e.deltaField, t), _this.textField = s(e.textField, t), _this.form = _this.htmlField ? _this.htmlField.form : _this.deltaField ? _this.deltaField.form : !!_this.textField && _this.textField.form, _this.form && (_this.form.addEventListener("submit", _this.update.bind(_assertThisInitialized(_this)), !0), _this.options.submitKey && _this.quill.keyboard.addBinding(_this.options.submitKey, _this.submit.bind(_assertThisInitialized(_this)))), _this.options.updateOnBlur && (_this.quill.on(r.a.events.SELECTION_CHANGE, function (t, e, i) {
          t || _this.update.call(_assertThisInitialized(_this));
        }), _this.form && _this.form.addEventListener("click", _this.update.bind(_assertThisInitialized(_this)), !0)), _this.options.updateOnChange && _this.quill.on(r.a.events.EDITOR_CHANGE, function (t, e, i, n) {
          t === r.a.events.TEXT_CHANGE && _this.update.call(_assertThisInitialized(_this));
        }), _this.update();
        return _this;
      }

      _createClass(o, [{
        key: "update",
        value: function update() {
          this.deltaField && (this.deltaField.value = JSON.stringify(this.quill.getContents())), this.htmlField && (this.htmlField.value = this.quill.root.innerHTML), this.textField && (this.textField.value = this.quill.root.innerText);
        }
      }, {
        key: "submit",
        value: function submit() {
          this.update.call(this), this.form && this.form.submit();
        }
      }]);

      return o;
    }(l);

    function s(t, e) {
      if (t instanceof HTMLInputElement) return t;

      if ("string" == typeof t) {
        var i = document.createElement("input");
        return i.type = "hidden", i.name = t, i.classList.add("ql-form-input"), i.classList.add("ql-form-" + t), e.addContainer(i), i;
      }

      if (!1 === t) return !1;
      throw new TypeError("Expected HTMLInputElement or string: " + t);
    }

    o.DEFAULTS = {
      htmlField: "html",
      deltaField: "delta",
      textField: "text",
      submitKey: {
        key: "S",
        shortKey: !0
      },
      updateOnBlur: !0,
      updateOnChange: !1
    }, r.a.register("modules/form", o);
  }]);
});